import { useState } from 'react';
import { Facebook, Twitter, Mail, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

const btnStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '8px 14px',
  border: '1px solid #ddd',
  borderRadius: '6px',
  background: '#fff',
  color: '#333',
  fontSize: '13px',
  cursor: 'pointer',
  textDecoration: 'none'
};

// url/title/text/imageUrl describe what's being shared; url defaults to the
// current page so this can be dropped in without extra plumbing.
function SocialShareButtons({ url, title, text, imageUrl }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const shareText = text || title || '';

  const openShare = (href) => {
    window.open(href, '_blank', 'noopener,noreferrer,width=600,height=500');
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Link copied');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error('Could not copy link');
    }
  };

  const facebookHref = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const twitterHref = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
  const pinterestHref = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(imageUrl || '')}&description=${encodeURIComponent(shareText)}`;
  const emailHref = `mailto:?subject=${encodeURIComponent(title || 'Check this out')}&body=${encodeURIComponent(`${shareText}\n\n${shareUrl}`)}`;

  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }} data-testid="social-share-buttons">
      <button type="button" style={btnStyle} onClick={() => openShare(facebookHref)}>
        <Facebook size={16} /> Facebook
      </button>
      <button type="button" style={btnStyle} onClick={() => openShare(twitterHref)}>
        <Twitter size={16} /> X
      </button>
      <button type="button" style={btnStyle} onClick={() => openShare(pinterestHref)}>
        Pinterest
      </button>
      <a href={emailHref} style={btnStyle}>
        <Mail size={16} /> Email
      </a>
      <button type="button" style={btnStyle} onClick={handleCopy}>
        {copied ? <Check size={16} /> : <Copy size={16} />} {copied ? 'Copied' : 'Copy Link'}
      </button>
    </div>
  );
}

export default SocialShareButtons;
